<template>
  <div class="text-gray-800">
    <slot />
  </div>
</template>
